
export default 
{
    menu: {
        quemSomos: 'ABOUT US',
        ondeAtuamos: 'WHAT WE DO',
        faleConosco: 'CONTACT US',
        produtos:'PRODUCTS'
    },
    quemSomos: {
        text1: `JAD Applications was born in January 2019 with the aim of helping
        quickly and conveniently create and maintain projects for
        software in Brazil and abroad`,
        text2: `Always aiming to offer innovative solutions that respond to operational and 
        productive needs in scalable products and services, JAD Applications was structured 
        based on the experience of several Technology projects and companies and focused on 
        best practices.`,
        text3: `With Senior professional staff, all with over 10 years of experience
              , certificates and over 30 years of age.`,
        text4: `We operate on two fronts: providing full support to developers and functional specialists—fixing errors 
        and suggesting implementations—and developing custom applications tailored to your business, 
        including e-commerce solutions, ERPs, system architecture, sales pages and landing pages, 
        web scraping, automation, scripts, chatbots, NFe, eSocial, and more.`,
    },
    ondeAtuamos: {
        text1: 'Here follows a brief presentation of our services, all with warranty:',
        
        produtos : 
        [
            {nome : 'JADS SUPPORT', valor: `First online company at the global level specially designed for professional support and bug fixing.`},
            {nome : 'IMPLEMENTATION', valor: `We install and configure your applications from scratch,SAP S/4 HANA,JAVA,.NET,REACT NATIVE, FLUTTER,BD'S.`},
            {nome : 'E-COMMERCE', valor: `Service platform for creating virtual stores.`},
            {nome : 'DEVELOPMENT', valor: `We develop any type of application:mobile, web, sales, entertainment, in the main languages`},
            {nome : 'DIGITAL MARKETING', valor: `Service that aims to leverage your business with sales techniques and business analysis`},        
            {nome : 'HOSTING', valor: `We offer test environment in hosting paid on our account, so that the user can do their tests`},
            {nome : 'VIRTUAL TRAINING', valor: `Online course platform, entitled to support via zoom,whats app, directly with our team - SAP, JAVA,.NET,ETC`}
        ]

    },
    produtos:{
        text2: 'Click here to display a few previews of our products:',
        text3: 'Financial',
        text4: 'Medical',
        text5: 'E-commerce',
        text6: 'Logistics',
        text7: 'Ifood',
        text8: 'Digital Bank',
        text9:'Games',
        text10:'PetShop'  
    }
   

}